import { TextareaAutosize } from '@mui/material';
import { styled } from '@mui/material/styles';

import { useFormContext, Controller } from 'react-hook-form';

import useSettings from 'globals/hooks/useSettings';

interface RHFTextAreaAutosize {
  name: string;
  placeholder?: string;
  other?: object;
  minRows?: number;
  maxRows?: number;
  style?: object;
}

const TextareaAutosizeStyled = styled(TextareaAutosize)(({ theme }) => ({
  background: 'none',
  borderRadius: '8px',
  padding: '16.5px 14px',
  font: 'inherit',
  '&:hover': {
    border: '1px solid #fff',
  },
  '&:focus': {
    border: 'none',
    outline: '2px solid #2065D1',
  },
}));

export default function RHFTextAreaAutosize({
  name,
  placeholder,
  minRows,
  maxRows,
  style,
  ...other
}: RHFTextAreaAutosize) {
  const { control } = useFormContext();

  const { getThemeMode } = useSettings();

  const currentTheme: any = getThemeMode();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextareaAutosizeStyled
          {...field}
          {...other}
          placeholder={placeholder}
          minRows={minRows}
          maxRows={maxRows}
          style={{ ...style, color: currentTheme === 'dark' ? '#fff' : '#000' }}
          {...other}
        />
      )}
    />
  );
}
